import * as React from "react";

$.fn.datepicker.dates['ru'] = {
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthsShort: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "нов", "дек"],
    today: "Today",
    clear: "Clear",
};

export default class CoreComponent<IState = {}, IProps = {}> extends React.Component<IState, IProps>{
    protected isUnmounted: boolean = false;

    componentWillUnmount() {
        this.isUnmounted = true;
    }
}